
const PUNTOSBALA = [
    <span><b>Descubre la innovación: 
    </b> Nuestra plataforma utiliza inteligencia artificial para ofrecerte la mejor experiencia de compra y venta de vehículos, respaldada por más de 25 años de experiencia.</span>,

    <span><b>Encuentra seguridad y comodidad:</b> Nuestro salón de exposición de 800m² y contratos personalizados garantizan seguridad y tranquilidad en tus operaciones, cumpliendo con la normativa vigente.</span>,

    <span><b>Vende tu auto sin preocupaciones:</b> Confía en nosotros para vender tu auto sin costo alguno, nuestro equipo se ocupa de todo para que tú no tengas que preocuparte de nada.</span>,


]
// const PUNTOSBALA = [
//     <span>No somos una agencia tradicional, <b>NO COBRAMOS COMISIÓN por nuestro trabajo</b>.</span>,
//     <span>Vendemos tu auto al mejor precio de mercado ya que <b>nuestro foco está en tu beneficio y hacer primero clientes</b>, no negocios.</span>,
//     <span>Contamos con un<b> equipo de más de 25 personas e instalaciones de primer nivel</b> donde atenderte como corresponde, brindarte un servicio de calidad y <b>vender o conseguir tu próximo tu auto en tiempo récord</b>.</span>,
//     <span>Trabajamos por <b>contrato</b> para tu <b>tranquilidad y seguridad</b>.</span>,
//     <span>Nos comprometemos a <b>vender o conseguir</b> tu próximo <b>auto en menos de 30 días.</b></span>,
//     <span><b>Nos encargamos de todo</b>, desde recibir tu auto, revisarlo y realizar un informe general, prepararlo para la venta, fotos, publicaciones, consultas, visitas, cierre de acuerdo, papeles y gestoría. <b>SIN CARGO.</b></span>
// ]

export default PUNTOSBALA;